import { getCurrentTimeNY, getFormattedDateYmd } from '../../../../global/helpers/date-helpers';
import { Employment, UnpaidLeave } from './employment-model';

const onLeave = (unpaidLeave: UnpaidLeave) => {
	const checkDate = getCurrentTimeNY();
	checkDate.setDate(checkDate.getDate() + 60);

	return (!unpaidLeave.end_date || getFormattedDateYmd(unpaidLeave.end_date) > getFormattedDateYmd(checkDate?.toString())) && getFormattedDateYmd(unpaidLeave.start_date) <= getFormattedDateYmd(checkDate?.toString());
};

export function isUnpaidLeave(employment: Employment) {
	if (!employment) return false;

	return employment.unpaid_leaves && employment.unpaid_leaves.length > 0 && employment.unpaid_leaves.filter(a => onLeave(a))?.length > 0;
}

